<template>
  <div>
    <div class="d-flex justify-end mb-3">
      <v-btn depressed color="var(--g)" class="mr-2" @click="importData" dark
        >Import</v-btn
      >
      <v-btn depressed color="var(--g)" @click="exportData" dark>Export</v-btn>
    </div>

    <div class="mb-3">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            placeholder="Search Scholar"
            solo
            v-model="find"
            @keyup="fetchData"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            hide-details
            :items="optStatusGPA"
            flat
            item-text="txt"
            dense
            solo
            item-value="val"
            v-model="status_gpa"
            @change="fetchData"
            placeholder="Status GPA"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            dense
            hide-details
            :items="getYear"
            item-text="state"
            item-value="abbr"
            v-model="year"
            @change="fetchData()"
            placeholder="Filter Year"
            flat
            solo
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" v-if="listTsa">
          <v-select
            dense
            hide-details
            :items="listTsa"
            item-text="name"
            item-value="id"
            v-model="tsa"
            @change="fetchData()"
            placeholder="Filter TSA"
            flat
            solo
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
        </v-col>
      </v-row>
    </div>
    <div>
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
        <template v-slot:[`item.name`]="{ item }">
            <router-link
              class="opener_name"
              :to="`/scholar/${item.user_id}`"
            >
              <p class="mb-0 black--text">{{ item.name }}</p>
            </router-link>
          </template>
          <template v-slot:[`item.no`]="{ item }">
            {{
              dataSet
                .map((x) => {
                  return x.id;
                })
                .indexOf(item.id) +
              1 +
              (page - 1) * limit
            }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <h5 style="font-weight: normal">
              {{ $date(item.created_at).format("MMM DD, YYYY") }}
            </h5>
          </template>
          <template v-slot:[`item.score`]="{ item }">
            <div
              class="dot_mark"
              :style="`background: ${
                item.score ? item.score.ip_mark : 'green'
              }`"
            ></div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="blue"
                    icon
                    small
                    class="mr-2"
                    @click="updateSubmission(item)"
                  >
                    <v-icon>mdi-sticker-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>

        <v-menu v-model="menuLimit" bottom :nudge-bottom="55" elevation="0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              class="text-capitalize color_txt mt-3"
              height="38px"
              color="#fff"
              v-bind="attrs"
              v-on="on"
              ><p class="default_txt">Show : {{ limit }}</p>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-card class="popup_radius" outlined elevation="0">
            <v-list>
              <v-list-item link @click="changeLimit(10)">
                <v-list-item-title>10</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="changeLimit(50)">
                <v-list-item-title>50</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="changeLimit(100)">
                <v-list-item-title>100</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <div class="text-center pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <v-card flat class="pa-3 rounded-lg my-2">
          <h3>Status GPA</h3>
          <div class="d-flex align-center">
            <div class="dot_mark mr-2 green"></div>
            GPA score is still eligible
          </div>
          <div class="d-flex align-center">
            <div class="dot_mark mr-2 yellow"></div>
            There is one GPA value that is below the requirements
          </div>
          <div class="d-flex align-center">
            <div class="dot_mark mr-2 red"></div>
            There is two GPA value in a row that is below the requirements
          </div>
        </v-card>
        <div class="pa-3">
          <dialog-large
            :d_large="d_large"
            @refetch="fetchData"
            @close="d_large = false"
            :inventory="inventory"
            :type="d_type"
            :title="d_title"
            line="true"
          />
        </div>
        <!-- <v-btn @click="koclok">koclok</v-btn> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "manageIpscholar",
  computed: {
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      menuLimit: false,
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      year: "",
      tab: null,
      find: "",
      tsa: "",
      listTsa: null,
      headers: [
        {
          text: "NO",
          align: "start",
          sortable: false,
          value: "no",
        },
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "no_tf",
        },
        {
          text: "FULL NAME",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "EMAIL",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          text: "STATUS GPA",
          align: "start",
          sortable: false,
          value: "score",
        },
        {
          text: "YEAR TF",
          align: "start",
          sortable: false,
          value: "year_tf",
        },
        { text: "TYPE", sortable: false, value: "type" },
        { text: "ACTION", sortable: false, value: "actions" },
      ],
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      status_gpa: "",
      optStatusGPA : [
        { txt: "Green", val: "green" },
        { txt: "Yellow", val: "yellow" },
        { txt: "Red", val: "red" },
        { txt: "All", val: "" },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.getTsa();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/scholar?filter[search]=${this.find}&filter[year_tf]=${this.year}&page[number]=${this.page}&filter[status_gpa]=${this.status_gpa}&filter[university_id]=${this.tsa}&page[size]=${this.limit}&include=score`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getTsa() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.listTsa = data.data;
          let reset = {
            id: "",
            name: "All TSA",
          };
          this.listTsa.unshift(reset);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateSubmission(item) {
      let score = item.score;
      let obj = {};
      if (score) {
        for (let key in score) {
          if (key.includes("semester")) {
            obj[key] = score[key] ? score[key] : "0.00";
          }
        }
      } else {
        for (let i = 0; i < 8; i++) {
          obj[`semester${i + 1}`] = "0.00";
        }
      }
      console.log(obj);
      let data = {
        name: item.name,
        no_tf: item.no_tf,
        id: item.id,
        data: obj,
      };

      this.d_type = "c_submission_admin";
      this.d_title = "Update Scholar GPA";
      this.d_large = true;
      this.inventory = data;
    },
    importData() {
      this.d_type = "i_ip";
      this.d_title = "";
      this.d_large = true;
      // this.inventory = data;
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
    koclok() {
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=70,left=-1000,top=-1000`;
      window.open("https://javascript.info/popup-windows", "test", params);
    },
    exportData() {
      let data = {
        path: `scholar/score/export?filter[search]=${this.find}&filter[year_tf]=${this.year}&page[number]=${this.page}&filter[university_id]=${this.tsa}&page[size]=${this.limit}&include=score`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.dot_mark {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>